import { Card, Checkbox, FormControl, InputLabel, MenuItem, Modal, Select } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDDatePicker from "components/MDDatePicker";
import moment from "moment";
import { useContext, useEffect, useState } from "react";
import MDButton from "components/MDButton";
import DataTable from "examples/Tables/DataTable";
import crudsService from "services/cruds-service";
import { AuthContext } from "context";


function SubscriptionDevice({ formData, setFormData, subscriptionPlanList }) {
    const [open, setOpen] = useState(false);
    const [selectedRows, setSelectedRows] = useState(null)
    const [selectedSubscription, setSelectedSubscription] = useState([])
    const [statusType, setStatusType] = useState([])
    const authContext = useContext(AuthContext)
    useEffect(() => {
        if (formData && formData?.plan_id) {
            setSelectedRows(formData?.plan_id)
            const filteredAddresses = subscriptionPlanList.filter(plan => formData?.plan_id == plan.plan_id);
            setSelectedSubscription(filteredAddresses);
        }

        const fetchStatus = async() => {
            let resp = await crudsService.getStatusTypes(19)

            if(resp?.data){
                setStatusType(resp.data)
            }
        }

        fetchStatus();

    }, [])
    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const changeStartDate = (value) => {
        let date = moment(value).format('YYYY-MM-DD');
        setFormData({ ...formData, start_date: date })
    }
    const changeEndDate = (value) => {
        let date = moment(value).format('YYYY-MM-DD');
        setFormData({ ...formData, end_date: date })
    }

    const addressHandler = () => {
        const filteredAddresses = subscriptionPlanList.filter(plan => selectedRows.includes(plan.plan_id));
        setSelectedSubscription(filteredAddresses);
        setFormData({ ...formData, plan_id: selectedRows[0] })
        setOpen(false);
    }

    const getPlanListRow = (list) => {
        let cloneList = JSON.parse(JSON.stringify(list));
        return cloneList.map((row) => {

            return {
                ...row,
                id: row.plan_id
            }
        })
    }

    const columnsPlan = [
        { Header: "Plan Name", accessor: "plan_name", width: "10%" },
        { Header: "Description", accessor: "description", width: "10%" },
        { Header: "Billing Cycle", accessor: "billing_cycle", width: "10%" },
        { Header: "Price Per Device", accessor: "price_per_device", width: "10%" },
    ]

    const styles = {
        fontSize: '0.875rem',
        color: '#ffffffcc'
    }

    return (
        <Card style={{ marginTop: '1rem' }}>
            <MDBox display="flex" flexDirection="column" px={3} my={2}>
                <div className="form-group" style={{ display: 'flex', gap: '10px', color: '#fff', alignItems: 'center', marginTop: '10px' }}>
                    <MDTypography fontWeight="bold" >Subscription</MDTypography>
                    {/* <MDTypography component="h5" htmlFor="plan">Plan</MDTypography> */}
                    <MDButton variant="gradient" color="dark" size="small" style={{ marginLeft: "1rem" }} onClick={handleOpen} disabled={authContext.userDetail.role_id == 6}>Assign Plan</MDButton>
                </div>
                <MDBox >
                    {selectedSubscription.length > 0 && (
                        <DataTable
                            table={{ columns: columnsPlan, rows: getPlanListRow(selectedSubscription) }}
                            // canSearch={true}
                            tableHeight="calc(100vh - 410px)"
                            canPagination={false}
                        />
                    )}
                </MDBox>
                <div className="form-group" style={{ display: 'flex', gap: '10px', color: '#fff', alignItems: 'center', marginTop: '10px' }}>
                    <MDTypography component="h6" sx={styles}  htmlFor="auto_renew">Auto Renew</MDTypography>
                    <Checkbox onChange={(e) => setFormData({ ...formData, auto_renew: e.target.checked })} checked={formData.auto_renew} disabled={authContext.userDetail.role_id == 6} />
                    <MDTypography component="h6" sx={styles} htmlFor="status_id">Status</MDTypography>
                    <FormControl required >
                        <InputLabel id="status_id">Status</InputLabel>
                        <Select
                            labelId="status_id"
                            id="status_id"
                            name="status_id"
                            value={formData.status_id}
                            label="Status"
                            onChange={(e) => setFormData({ ...formData, status_id: e.target.value })}
                            sx={{
                                '& .MuiSelect-select': {
                                    minHeight: '3em !important'
                                },
                                width: '10rem'
                            }}
                            required
                            readOnly={authContext.userDetail.role_id == 6}
                        >
                            <MenuItem value="">Select an option</MenuItem>
                            {statusType.length > 0 && statusType.map((elm) => (
                                <MenuItem value={elm.id}>{elm.attributes.StatusType.status_name}</MenuItem>
                            ))}
                            {/* <MenuItem value="yearly">Yearly</MenuItem> */}
                        </Select>
                    </FormControl>
                    <MDTypography component="h6" sx={styles} htmlFor="start_date">Start Date</MDTypography>
                    <MDDatePicker
                        id="start_date"
                        value={formData.start_date ? new Date(formData.start_date) : null}
                        onChange={(date) => changeStartDate(date[0])}
                        options={{
                            dateFormat: "Y-m-d",
                            enableTime: false,
                        }}
                        input={{ placeholder: "Start Date", disabled: authContext.userDetail.role_id == 6 }}
                        required
                    />
                    <MDTypography component="h6" sx={styles} htmlFor="end_date">End Date</MDTypography>
                    <MDDatePicker
                        id="end_date"
                        value={formData.end_date ? new Date(formData.end_date) : null}
                        onChange={(date) => changeEndDate(date[0])}
                        options={{
                            dateFormat: "Y-m-d",
                            enableTime: false,
                        }}
                        input={{ placeholder: "End Date", disabled: authContext.userDetail.role_id == 6 }}
                    />
                </div>
                {/* <div className="form-group" style={{ display: 'flex', gap: '10px', color: '#fff', alignItems: 'center', marginTop: '10px' }}>
                    <MDTypography component="p" htmlFor="start_date">Start Date</MDTypography>
                    <MDDatePicker
                        id="start_date"
                        value={formData.start_date ? new Date(formData.start_date) : null}
                        onChange={(date) => changeStartDate(date[0])}
                        options={{
                            dateFormat: "Y-m-d",
                            enableTime: false,
                        }}
                        input={{ placeholder: "Start Date" }}
                    />
                </div>
                <div className="form-group" style={{ display: 'flex', gap: '10px', color: '#fff', alignItems: 'center', marginTop: '10px' }}>
                    <MDTypography component="p" htmlFor="end_date">End Date</MDTypography>
                    <MDDatePicker
                        id="end_date"
                        value={formData.end_date ? new Date(formData.end_date) : null}
                        onChange={(date) => changeEndDate(date[0])}
                        options={{
                            dateFormat: "Y-m-d",
                            enableTime: false,
                        }}
                        input={{ placeholder: "End Date" }}
                    />
                </div>
                <div className="form-group" style={{ display: 'flex', gap: '10px', color: '#fff', alignItems: 'center', marginTop: '10px' }}>
                    <MDTypography component="p" htmlFor="status_id">Status</MDTypography>
                    <FormControl sx={{ mt: 1 }} required>
                        <InputLabel id="status_id">Status</InputLabel>
                        <Select
                            labelId="status_id"
                            id="status_id"
                            name="status_id"
                            value={formData.status_id}
                            label="Status"
                            onChange={(e) => setFormData({ ...formData, status_id: e.target.value })}
                            sx={{
                                '& .MuiSelect-select': {
                                    minHeight: '3em !important'
                                },
                                width: '10rem'
                            }}
                            required
                        >
                            <MenuItem value="">Select an option</MenuItem>
                            {statusType.length > 0 && statusType.map((elm) => (
                                <MenuItem value={elm.id}>{elm.attributes.StatusType.status_name}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </div> */}
            </MDBox>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-title"
                aria-describedby="modal-description"
            >
                <Card
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: '80%', // Set the desired width here
                        backgroundColor: 'white',
                        border: '2px solid #000',
                        boxShadow: 24,
                        p: 4,
                    }}
                >
                    {/* <CardContent> */}
                    <MDTypography>Select Plan</MDTypography>
                    <DataTable table={{ columns: columnsPlan, rows: getPlanListRow(subscriptionPlanList) }} selectedRows={selectedRows} setSelectedRows={setSelectedRows} isSelection={true} isMultiSelect={false} canSearch={true} />
                    <MDBox ml="auto" mt={3} display="flex" justifyContent="flex-end">
                        <MDButton variant="contained" color="secondary" onClick={handleClose}>
                            Cancel
                        </MDButton>
                        <MDButton variant="contained" color="info" onClick={addressHandler} style={{ marginLeft: '10px' }}>
                            Save
                        </MDButton>
                    </MDBox>
                    {/* </CardContent> */}
                </Card>
            </Modal>
        </Card>
    )

}

export default SubscriptionDevice;